import React from 'react';
import classnames from 'classnames';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import { useDeviationAttributes } from '../../_partials/hooks/useDeviationAttributes';
import SubscribersOnly from '../../_partials/SubscribersOnly';
import CommentButton from '../../buttons/CommentButton';
import FavouriteButton from '../../buttons/FavouriteButton';
import AddToGroupButton from '../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../buttons/MoreButton';
import EditButton from '../../buttons/EditButton';
import EditBackgroundButton from '../../buttons/EditBackgroundButton';
import DeleteButton from '../../buttons/DeleteButton';
import TheaterButton from '../../buttons/TheaterButton';
import ExpandButton from '../../buttons/ExpandButton';
import TierButton from '../../buttons/TierButton';
import s from './TierActionBar.scss';
export var TierActionBar = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, className = _a.className;
    var _b = useDeviationAttributes(deviation, isOwner), hasMoreActions = _b.hasMoreActions, isCommentable = _b.isCommentable, isEditable = _b.isEditable, isDeletable = _b.isDeletable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, isBackgroundEditable = _b.isBackgroundEditable;
    return (React.createElement(ActionBarStrip, { className: classnames(s['root'], className) },
        React.createElement("div", { className: s['indicators'] },
            React.createElement(SubscribersOnly, { deviation: deviation })),
        React.createElement("div", { className: s['actions'] },
            React.createElement("div", { className: s['main-actions'] },
                isFavouritable && (React.createElement(FavouriteButton, { deviation: deviation, actionBarType: "primary" })),
                isCommentable && (React.createElement(CommentButton, { deviation: deviation, 
                    // TODO: this is a hack to show the 'comment' label because we have the space, owner or not
                    isOwner: false, actionBarType: "primary" }))),
            React.createElement("div", { className: s['extra-actions'] },
                isGroupSubmittable && (React.createElement(AddToGroupButton, { deviation: deviation, actionBarType: "primary" })),
                !isOwner && (React.createElement(TierButton, { deviation: deviation, className: s['subscribe-button'] })),
                hasMoreActions && React.createElement(MoreButton, { deviation: deviation }),
                isBackgroundEditable && (React.createElement(EditBackgroundButton, { deviation: deviation })),
                isDeletable && React.createElement(DeleteButton, { deviation: deviation }),
                isEditable && React.createElement(EditButton, { deviation: deviation }))),
        React.createElement("div", { className: s['view-controls'] },
            React.createElement(TheaterButton, { deviation: deviation }),
            React.createElement(ExpandButton, { deviation: deviation }))));
};
TierActionBar.displayName = 'TierActionBar';
export default TierActionBar;
//# sourceMappingURL=TierActionBar.js.map